import { Component } from '@angular/core';
import { BrowserPage } from '../../comm/browser/browser';
import { NewsDetail } from '../news/detail/detail';
import { NewsListPage } from '../news/list/list';
import { MyServicesPage } from '../myservices/myservices';
import { WebService } from '../../../providers/service/webservice';
import { SEARCH } from '../../../providers/config/serviceurl';
import { App } from 'ionic-angular';
import { StorageService } from '../../../providers/service/storageservice';
import { AddressBookList } from '../../application/dailyoffice/addressbook/list/addressbooklist';
import { CardQueryPage } from '../../application/life/card/cardquery';
import { BooksOverview } from '../../application/life/books/overview/mybooks';
import { HelpCenter } from '../../application/dailyoffice/helpcenter/overview/helpcenter';
import { UnifiedAddressBookList } from '../../application/dailyoffice/unifiedaddressbook/list/unifiedaddressbooklist';
import { PersonalInfo } from '../../application/teaching/personalinfo/personalinfo';
import { ClassSchedule } from '../../application/teaching/classschedule/classschedule';
import { ElectiveResult } from '../../application/teaching/elective/electiveresult';
import { ScoreQueryPage } from '../../application/teaching/score/scorequery';
import { FreeClassroom } from '../../application/teaching/freeclassroom/freeclassroom';
import { ProjectList } from '../../application/research/project/list/projectlist';
import { ProjectFundingList } from '../../application/research/profunding/list/list';
import { ThesisList } from '../../application/research/thesis/list/list';
import { ProductionList } from '../../application/research/production/list/list';
import { CopyrightList } from '../../application/research/copyright/list/list';
import { SalaryInquiry } from '../../application/finance/salary/salaryinquiry';
import { ReportList } from '../../application/research/report/list/list';
import { PrizeList } from '../../application/research/prize/list/list';
import { IdentificationList } from '../../application/research/identification/list/list';
import { PatentList } from '../../application/research/patent/list/list';
import { AppointInfo } from '../../application/personnel/appoint/appointinfo/appointinfo';
import { FRZSQ} from '../../../providers/config/serviceurl';
import { YZSQ} from '../../../providers/config/serviceurl';
import { XZSQSQ} from '../../../providers/config/serviceurl';
import { SSKTSQ} from '../../../providers/config/serviceurl';
import { JSQKDRWSQ} from '../../../providers/config/serviceurl';

import { AppState } from '../../../app/app.global';
@Component({
  selector: 'search-page',
  templateUrl: 'search.html'
})
export class SearchPage {
  historyKeys: any;//显示关键字
  historyFlag:boolean=true;//控制是否显示历史数据
  newsListFlag:boolean=false;//控制是否显示
  applyListFlag:boolean=false;
  nothingTipFlag:boolean=false;
  keyword:string;//关键字
  hisItems:any=[];//获取搜索内容的数组
  newsList:any[];//新闻列表
  applyList:any[];//服务列表
  applyList2:any=[];//服务列表备份
  newsLength:number=0;//新闻列表的长度
  applyLength:number=0;//服务列表的长度
	user:any={}
	currentUser:any = {};
  constructor(public appCtrl: App,public global: AppState,private webService:WebService) {
  	if(localStorage['hisItems']!=undefined&&localStorage['hisItems']!=""){
  		this.historyKeys = JSON.parse(localStorage.getItem('hisItems')).reverse();
  	}
  	this.user = StorageService.getObj('currentUser');
  	if(this.user!=null&&this.user&&this.user.userId!=null&&this.user.userId!=''&&this.user.role!=''){
  		if(this.user.role=='staff'){//教职工
  			this.applyList2 = [
  			//{'id':"1",'name':'一卡通','applyIcon':'assets/icon/yktcx.svg','func':CardQueryPage,'isBrowser':'N'},
  			//{'id':"2",'name':'我的图书','applyIcon':'assets/icon/wdts.svg','func':BooksOverview,'isBrowser':'N'},
  			{'id':"3",'name':'通讯录','applyIcon':'assets/icon/tytxl.svg','func':UnifiedAddressBookList,'isBrowser':'N'},
  			{'id':"4",'name':'帮助中心','applyIcon':'assets/icon/bzzz.svg','func':HelpCenter,'isBrowser':'N'},
  			{'id':"5",'name':'课程表','applyIcon':'assets/icon/kbcx.svg','func':ClassSchedule,'isBrowser':'N'},
  			{'id':"6",'name':'空闲教室','applyIcon':'assets/icon/kxjs.svg','func':FreeClassroom,'isBrowser':'N'},
  			{'id':"7",'name':'科研项目','applyIcon':'assets/icon/kyxm.svg','func':ProjectList,'isBrowser':'N'},
  			//{'id':"8",'name':'项目经费','applyIcon':'assets/icon/xmjf.svg','func':ProjectFundingList,'isBrowser':'N'},
  			{'id':"9",'name':'论文成果','applyIcon':'assets/icon/lwcg.svg','func':ThesisList,'isBrowser':'N'},
  			{'id':"10",'name':'著作成果','applyIcon':'assets/icon/zzcg.svg','func':ProductionList,'isBrowser':'N'},
  			{'id':"11",'name':'著作权成果','applyIcon':'assets/icon/zzqcg.svg','func':CopyrightList,'isBrowser':'N'},
  			{'id':"12",'name':'工资查询','applyIcon':'assets/icon/gzcx.svg','func':SalaryInquiry,'isBrowser':'N'},
  			//{'id':"13",'name':'研究报告成果','applyIcon':'assets/images/blue_icon.svg','func':ReportList,'isBrowser':'N'},
  			{'id':"14",'name':'获奖成果','applyIcon':'assets/icon/hjcg.svg','func':PrizeList,'isBrowser':'N'},
  			{'id':"15",'name':'鉴定成果','applyIcon':'assets/icon/jdcg.svg','func':IdentificationList,'isBrowser':'N'},
  			{'id':"16",'name':'专利成果','applyIcon':'assets/icon/zlcg.svg','func':PatentList,'isBrowser':'N'}
  			//{'id':"17",'name':'专业技术职务聘任','applyIcon':'assets/icon/zwpr.svg','func':AppointInfo,'isBrowser':'N'},
  			//{'id':"18",'name':'印章申请办理','applyIcon':'assets/icon/yz3.svg','func':AppointInfo,'isBrowser':'yz3'},
  			//{'id':"19",'name':'法人证申请','applyIcon':'assets/icon/yz2.svg','func':AppointInfo,'isBrowser':'yz2'},
  			//{'id':"20",'name':'校长审签申请','applyIcon':'assets/icon/yz1.svg','func':AppointInfo,'isBrowser':'yz1'},
  			//{'id':"21",'name':'家属区宽带入网','applyIcon':'assets/icon/kd.svg','func':AppointInfo,'isBrowser':'kd'}
  			];
  		}else if(this.user.role=='student'){//学生
  			this.applyList2 = [
  			//{'id':"1",'name':'一卡通','applyIcon':'assets/icon/yktcx.svg','func':CardQueryPage,'isBrowser':'N'},
  			//{'id':"2",'name':'我的图书','applyIcon':'assets/icon/wdts.svg','func':BooksOverview,'isBrowser':'N'},
  			{'id':"3",'name':'通讯录','applyIcon':'assets/icon/tytxl.svg','func':UnifiedAddressBookList,'isBrowser':'N'},
  			{'id':"4",'name':'帮助中心','applyIcon':'assets/icon/bzzz.svg','func':HelpCenter,'isBrowser':'N'},
  			{'id':"5",'name':'课程表','applyIcon':'assets/icon/kbcx.svg','func':ClassSchedule,'isBrowser':'N'},
  			{'id':"6",'name':'选课结果','applyIcon':'assets/icon/xkjg.svg','func':ElectiveResult,'isBrowser':'N'},
  			{'id':"7",'name':'成绩查询','applyIcon':'assets/icon/cjcx.svg','func':ScoreQueryPage,'isBrowser':'N'},
  			{'id':"8",'name':'空闲教室','applyIcon':'assets/icon/kxjs.svg','func':FreeClassroom,'isBrowser':'N'}
  			//{'id':"9",'name':'宿舍空调申请','applyIcon':'assets/icon/kt.svg','func':AppointInfo,'isBrowser':'kt'}
  			];
  			
  		}else if(this.user.role=='tourists'){//临时人员
  			this.applyList2 = [
  			//{'id':"1",'name':'一卡通','applyIcon':'assets/icon/yktcx.svg','func':CardQueryPage,'isBrowser':'N'},
  			//{'id':"2",'name':'我的图书','applyIcon':'assets/icon/wdts.svg','func':BooksOverview,'isBrowser':'N'},
  			{'id':"3",'name':'通讯录','applyIcon':'assets/icon/tytxl.svg','func':UnifiedAddressBookList,'isBrowser':'N'},
  			{'id':"4",'name':'帮助中心','applyIcon':'assets/icon/bzzz.svg','func':HelpCenter,'isBrowser':'N'},
  			{'id':"5",'name':'空闲教室','applyIcon':'assets/icon/kxjs.svg','func':FreeClassroom,'isBrowser':'N'}
  			];
  		}
  	}else{//游客
  		this.applyList2 = [
  			{'id':"1",'name':'通讯录','applyIcon':'assets/icon/tytxl.svg','func':UnifiedAddressBookList,'isBrowser':'N'},
  			{'id':"2",'name':'帮助中心','applyIcon':'assets/icon/bzzz.svg','func':HelpCenter,'isBrowser':'N'}
  			];
  	}
  }
  
  search(){
  	if(this.applyList2&&this.applyList2.length>0&&this.keyword!=null&&this.keyword!=''){
  		var length = this.applyList2.length;
  		var list:any=[];var j=0;
  		for(var i=0;i<length;i++){
  			if(this.applyList2[i].name.indexOf(this.keyword) >= 0){
  				list[j] = this.applyList2[i];
  				j++;
  			}
  		}
  		this.applyLength = list.length;
  		this.applyList = list;
  	}else{
  		this.applyLength = 0;
  		this.applyList = [];
  	}
  	
  }
 
  myServicesMore(){
  	this.appCtrl.getRootNav().push(MyServicesPage);
  }
  
  toApplyFunc(pageItem:any,isBrowser:string){
  	if(isBrowser=='N'){
  		this.appCtrl.getRootNav().push(pageItem);
  	}else{
  		if(isBrowser=='yz3'){//印章申请办理
  			this.goToRepair();
  		}else if(isBrowser=='yz2'){//法人证申请
  			this.goToRepair2();
  		}else if(isBrowser=='yz1'){//校长审签申请
  			this.goToRepair3();
  		}else if(isBrowser=='kd'){//宽带
  			this.goToRepair5();
  		}else if(isBrowser=='kt'){//空调
  			this.goToRepair4();
  		}
  	}
  }
  
	 goToRepair(){
    this.currentUser = StorageService.getObj("currentUser");
	 	this.appCtrl.getRootNav().push(BrowserPage,{
						browser: {title: '印章申请办理', url: YZSQ+"?hd="+this.currentUser.hd}});
	 }
	 goToRepair2(){
    this.currentUser = StorageService.getObj("currentUser");
	 	this.appCtrl.getRootNav().push(BrowserPage,{
      browser: {title: '法人证申请', url: FRZSQ+"?hd="+this.currentUser.hd}});
	 }
	 goToRepair3(){
    this.currentUser = StorageService.getObj("currentUser");
	 	this.appCtrl.getRootNav().push(BrowserPage,{
						browser: {title: '校长审签申请', url:XZSQSQ+"?hd="+this.currentUser.hd}});
	 }
	 goToRepair4(){
    this.currentUser = StorageService.getObj("currentUser");
	 	this.appCtrl.getRootNav().push(BrowserPage,{
						browser: {title: '宿舍空调申请', url:SSKTSQ+"?hd="+this.currentUser.hd}});
	 }
	 goToRepair5(){
    this.currentUser = StorageService.getObj("currentUser");
	 	this.appCtrl.getRootNav().push(BrowserPage,{
						browser: {title: '家属区宽带入网申请', url:JSQKDRWSQ+"?hd="+this.currentUser.hd}});
	 }
	 
	  historyClick(keyword:string){
  	this.keyword = keyword;
  }
  
  saveHistory(keyword:string){
  	keyword = keyword.replace(/(^\s+)|(\s+$)/g,"").replace(/\s/g,"");//去除前后空格和中间的空格
  	if(localStorage['hisItems']==undefined||localStorage['hisItems']==""){
  		this.hisItems.push(keyword);
  		localStorage.setItem('hisItems',JSON.stringify(this.hisItems));
  	}else{
  		this.hisItems = JSON.parse(localStorage.getItem('hisItems'));
  		let index = this.hisItems.indexOf(keyword);
  		if(-1 < index){
  			this.hisItems.splice(index,1);
  		}
  		if(this.hisItems.length < 20){
  			this.hisItems.push(keyword);
  			localStorage.setItem('hisItems',JSON.stringify(this.hisItems));
  		}else{
  			this.hisItems.shift();
  			this.hisItems.push(keyword);
  			localStorage.setItem('hisItems',JSON.stringify(this.hisItems));
  		}
  	}
  }
  clearHistory(){
  	localStorage.removeItem('hisItems');
  	this.hisItems = [];
  	this.historyKeys = [];
  }
  cancel(){
    	this.appCtrl.getRootNav().pop();
  }
  openItemDetail(event:any, item:any){
  	if(item!=null&&item!='undefined'&&item!=''
  		&&item.link!=null&&item.link!='undefined'&&item.link!=''){
  		this.appCtrl.getRootNav().push(BrowserPage,{
						browser: {title: item.title, url: item.link}});
  	}else{
  		this.appCtrl.getRootNav().push(NewsDetail,item);
  	}
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/search/search.ts